import { Component, OnInit, Input } from '@angular/core';
import { Alignment } from 'src/app/core/types';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent {

  @Input()
  firstPart: string;

  @Input()
  secondPart: string;

  @Input()
  separator: boolean;

  @Input()
  align: Alignment = 'left';
}
